// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"91154b55","475":"02bb78b6","781":"3d8dc085"}[chunkId] + ".chunk.js";
};